import React, { useState, useEffect } from 'react';
import { Box, Button, Typography, Link } from '@mui/material';

function CookieConsent() {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const consent = localStorage.getItem('cookieConsent');
    if (!consent) {
      setVisible(true);
    }
  }, []);

  const handleAccept = () => {
    localStorage.setItem('cookieConsent', 'accepted');
    setVisible(false);
  };

  const handleDecline = () => {
    localStorage.setItem('cookieConsent', 'declined');
    setVisible(false);
  };

  if (!visible) return null;

  return (
    <Box
      sx={{
        position: 'fixed',
        bottom: 0,
        left: 0,
        right: 0,
        background: '#fff',
        boxShadow: '0 -2px 10px rgba(0,0,0,0.1)',
        padding: 2,
        zIndex: 9999,
        borderTop: '3px solid #1976d2',
      }}
    >
      <Box sx={{ maxWidth: 1200, margin: '0 auto', display: 'flex', alignItems: 'center', gap: 2, flexWrap: 'wrap' }}>
        <Typography variant="body2" sx={{ flex: 1, minWidth: 300 }}>
          We use cookies and similar technologies to improve your experience, show personalized ads, and analyze traffic.
          By continuing to use this site, you consent to our use of cookies.{' '}
          <Link href="/privacy" target="_blank" sx={{ textDecoration: 'underline' }}>
            Privacy Policy
          </Link>
          {' | '}
          <Link href="/terms" target="_blank" sx={{ textDecoration: 'underline' }}>
            Terms of Service
          </Link>
        </Typography>
        <Box sx={{ display: 'flex', gap: 1 }}>
          <Button variant="outlined" size="small" onClick={handleDecline}>
            Decline
          </Button>
          <Button variant="contained" size="small" onClick={handleAccept}>
            Accept
          </Button>
        </Box>
      </Box>
    </Box>
  );
}

export default CookieConsent;
